export default "__VITE_ASSET__CVCe0Mq1__"